<template>
  <router-link :to="/persons/ + person.personId" class="card">
    <div class="card-header" >{{ person.name }}</div>
    <div class="card-details">
      <div v-if="person.federationNumber!=null">{{ $t('persons.federationNumber') }} : {{person.federationNumber}}</div>
      <div v-if="person.federationNumber==null">geen bondslid</div>
    </div>
  </router-link>
</template>

<script>

export default {
  name: 'PersonCard',
  components: {},
  props: {
    person: {
      type: Object,
      required: true
    }
  },
  methods: {
    showPerson: function(personId) {
      this.$router.push({name: 'PersonDetails', params: {personId: personId}});
    }
  }
}
</script>

<style scoped>


</style>
